import React from "react"
import CustomButton from "../../components/custom-button/custom-button.component"

import * as S from "./nonprofit-banner.styles"

const NonprofitBanner = props => {
  const { backgroundImage, logo, description, button } = props
  return (
    <S.Section>
      <S.Wrapper maxWidth="xl">
        <S.BackgroundImage img={backgroundImage}>
          <S.ContentContainer>
            <S.Logo img={logo} />
            <S.Description>{description}</S.Description>
            <CustomButton
              href={button?.url}
              target="_blank"
              className="linearGradient"
            >
              {button?.title}
            </CustomButton>
          </S.ContentContainer>
        </S.BackgroundImage>
      </S.Wrapper>
    </S.Section>
  )
}

export default NonprofitBanner
